/* eslint-disable prettier/prettier */
/* eslint-disable object-shorthand */
/* eslint-disable prettier/prettier */
import "./smartProperties.css";
import { is, getBusinessObject } from "bpmn-js/lib/util/ModelUtil";
import entryFactory from "bpmn-js-properties-panel/lib/factory/EntryFactory";
import cmdHelper from "bpmn-js-properties-panel/lib/helper/CmdHelper";
import elementHelper from "bpmn-js-properties-panel/lib/helper/ElementHelper";
import {
  getExtensionElements,
  removeEntry,
} from "bpmn-js-properties-panel/lib/helper/ExtensionElementsHelper";
import formHelper from "bpmn-js-properties-panel/lib/helper/FormHelper";
import each from "lodash/forEach";

import extensionElements from "./smartExtensionElements";
import smartFormGerarLinkPublicoButton from "./smartFormGerarLinkPublicoButton";
import smartFormPreviewButton from "./smartFormPreviewButton";

function ensureFormKeyAndDataSupported(element) {
  return (
    (is(element, "bpmn:StartEvent") &&
      !is(element.parent, "bpmn:SubProcess")) ||
    is(element, "bpmn:UserTask")
  );
}

export default function (group, element, bpmnFactory, translate, modeling) {
  const formFieldsEntry = extensionElements(
    element,
    bpmnFactory,
    {
      id: "form-fields",
      label: translate("Form Fields"),
      modelProperty: "id",
      prefix: "FormField",
      canOrder: true,
      createExtensionElement(element, extensionElements, value) {
        const bo = getBusinessObject(element),
          commands = [];

        if (!extensionElements) {
          extensionElements = elementHelper.createElement(
            "bpmn:ExtensionElements",
            { values: [] },
            bo,
            bpmnFactory,
          );
          commands.push(
            cmdHelper.updateProperties(element, {
              extensionElements,
            }),
          );
        }

        let formData = formHelper.getFormData(element);

        if (!formData) {
          formData = elementHelper.createElement(
            "camunda:FormData",
            { fields: [] },
            extensionElements,
            bpmnFactory,
          );
          commands.push(
            cmdHelper.addAndRemoveElementsFromList(
              element,
              extensionElements,
              "values",
              "extensionElements",
              [formData],
              [],
            ),
          );
        }

        const field = elementHelper.createElement(
          "camunda:FormField",
          { id: value },
          formData,
          bpmnFactory,
        );

        if (typeof formData.fields !== "undefined") {
          commands.push(
            cmdHelper.addElementsTolist(element, formData, "fields", [field]),
          );
        } else {
          commands.push(
            cmdHelper.updateBusinessObject(element, formData, {
              fields: [field],
            }),
          );
        }
        return commands;
      },
      removeExtensionElement(element, extensionElements, value, idx) {
        const formData = getExtensionElements(
            getBusinessObject(element),
            "camunda:FormData",
          )[0],
          entry = formData.fields[idx],
          commands = [];

        if (formData.fields.length < 2) {
          commands.push(
            removeEntry(getBusinessObject(element), element, formData),
          );
        } else {
          commands.push(
            cmdHelper.removeElementsFromList(
              element,
              formData,
              "fields",
              null,
              [entry],
            ),
          );

          if (entry.id === formData.get("businessKey")) {
            commands.push(
              cmdHelper.updateBusinessObject(element, formData, {
                businessKey: undefined,
              }),
            );
          }
        }

        return commands;
      },
      getExtensionElements(element) {
        return formHelper.getFormFields(element);
      },
      hideExtensionElements(element, node) {
        return false;
      },
    },
    translate,
    modeling,
  );
  if (!ensureFormKeyAndDataSupported(element)) {
    return;
  }

  function hasStepperField(element) {
    const formFields = formHelper.getFormFields(element) || [];
    for (let i = 0; i < formFields.length; i++) {
      const field = formFields[i];
      const props =
        field &&
        (typeof field.get === "function"
          ? field.get("properties")
          : field.properties);
      if (!props || !props.values || !props.values.length) continue;
      for (let j = 0; j < props.values.length; j++) {
        const prop = props.values[j];
        const val = prop && prop.value;
        if (!val) continue;
        const data = JSON.parse(val);
        const t = data && data.type ? String(data.type) : "";
        if (
          t === "Etapa" ||
          t.toLowerCase() === "stepper" ||
          t.toLowerCase().includes("etapa")
        ) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Return the currently selected form field querying the form field select box
   * from the DOM.
   *
   * @param  {djs.model.Base} element
   * @param  {DOMElement} node - DOM element of any form field text input
   *
   * @return {ModdleElement} the currently selected form field
   */
  // eslint-disable-next-line no-unused-vars
  function getSelectedFormField(element, node) {
    const selected = formFieldsEntry.getSelected(element, node.parentNode);

    if (selected.idx === -1) {
      return;
    }

    return formHelper.getFormField(element, selected.idx);
  }
  // [FormData] business key form field select box
  // eslint-disable-next-line no-unused-vars
  const fKey = entryFactory.selectBox(translate, {
    id: "form-key-selectBox",
    label: translate("Form Keys"),
    modelProperty: "formKeySelectBox",
    selectOptions(element, inputNode) {
      const bo = getBusinessObject(element);
      let formKey = bo.get("camunda:formKey");
      const selectOptions = [{ name: "", value: "" }];
      //var formFields = formHelper.getFormFields(element);
      if (formKey) {
        formKey = formKey.split(", ");
        each(formKey, function (fKeyName) {
          selectOptions.push({ name: fKeyName, value: fKeyName });
        });
      }
      return selectOptions;
    },
    get(element, node) {
      let result = { formKey: "" };
      const bo = getBusinessObject(element);
      let formKey = bo.get("camunda:formKey");
      if (formKey) {
        formKey = formKey.split(", ");
      }
      //  var formDataExtension = bo.get("camunda:formKey");
      if (formKey) {
        const formData = formKey[0];
        //var storedValue = formData.get("businessKey");
        result = { formKey: formData };
      }
      return result;
    },
    set(element, values, node) {
      let formData = getBusinessObject(element).get("formKey");
      formData = formData ? formData.split(", ")[0] : formData;
      return cmdHelper.updateBusinessObject(element, formData, {
        formKey: values || undefined,
      });
    },
  });
  //group.entries.push(fKey);
  // [FormKey] form key text input field
  group.entries.push(
    entryFactory.textField(translate, {
      id: "form-key",
      label: translate("Form Key"),
      modelProperty: "formKey",
      get(element, node) {
        const bo = getBusinessObject(element);

        return {
          formKey: bo.get("camunda:formKey"),
        };
      },
      set(element, values, node) {
        const bo = getBusinessObject(element),
          formKey = values.formKey || undefined;

        return cmdHelper.updateBusinessObject(element, bo, {
          "camunda:formKey": formKey,
        });
      },
    }),
  );
  group.entries.push(formFieldsEntry);

  //Botão de preview dos formulários
  const formPreviewButton = smartFormPreviewButton(
    element,
    bpmnFactory,
    {
      id: "forms-preview-button",
    },
    translate,
    modeling,
  );
  group.entries.push(formPreviewButton);

  // [FormData] business key form field select box
  const formBusinessKeyFormFieldEntry = entryFactory.selectBox(translate, {
    id: "form-business-key",
    label: translate("Business Key"),
    modelProperty: "businessKey",
    selectOptions(element, inputNode) {
      const selectOptions = [{ name: "", value: "" }];
      const formFields = formHelper.getFormFields(element);
      each(formFields, function (field) {
        if (field.type !== "boolean") {
          selectOptions.push({ name: field.id, value: field.id });
        }
      });
      return selectOptions;
    },
    get(element, node) {
      let result = { businessKey: "" };
      const bo = getBusinessObject(element);
      const formDataExtension = getExtensionElements(bo, "camunda:FormData");
      if (formDataExtension) {
        const formData = formDataExtension[0];
        const storedValue = formData.get("businessKey");
        result = { businessKey: storedValue };
      }
      return result;
    },
    set(element, values, node) {
      const formData = getExtensionElements(
        getBusinessObject(element),
        "camunda:FormData",
      )[0];
      return cmdHelper.updateBusinessObject(element, formData, {
        businessKey: values.businessKey || undefined,
      });
    },
    hidden(element, node) {
      const isStartEvent = is(element, "bpmn:StartEvent");
      return !(isStartEvent && formHelper.getFormFields(element).length > 0);
    },
  });
  group.entries.push(formBusinessKeyFormFieldEntry);

  group.entries.push(
    entryFactory.textField(translate, {
      id: "smart-bpm-conclusion-button",
      label: translate("Texto utilizado no botão Concluir do formulário."),
      modelProperty: "smartBpmConclusionButton",

      get(element) {
        const businessObject = getBusinessObject(element);
        const extensionElements = businessObject.extensionElements;

        if (extensionElements && extensionElements.values) {
          const propertiesElement = extensionElements.values.find(
            (el) => el.$type === "camunda:Properties",
          );

          if (propertiesElement && propertiesElement.values) {
            const property = propertiesElement.values.find(
              (p) => p.name === "smartBpmConclusionButton",
            );

            if (property) {
              return { smartBpmConclusionButton: property.value };
            }
          }
        }

        return { smartBpmConclusionButton: "" };
      },

      set(element, values) {
        const commands = [];
        const businessObject = getBusinessObject(element);

        // Garante camunda:extensionElements
        let extensionElements = businessObject.extensionElements;
        if (!extensionElements) {
          extensionElements = elementHelper.createElement(
            "bpmn:ExtensionElements",
            { values: [] },
            businessObject,
            bpmnFactory,
          );
          commands.push(
            cmdHelper.updateBusinessObject(element, businessObject, {
              extensionElements,
            }),
          );
        }

        // Garante camunda:Properties
        let propertiesElement = extensionElements.values.find(
          (el) => el.$type === "camunda:Properties",
        );
        if (!propertiesElement) {
          propertiesElement = elementHelper.createElement(
            "camunda:Properties",
            { values: [] },
            extensionElements,
            bpmnFactory,
          );
          commands.push(
            cmdHelper.addElementsTolist(element, extensionElements, "values", [
              propertiesElement,
            ]),
          );
        }

        // Atualiza ou cria a propriedade smartBpmConclusionButton
        const property = propertiesElement.values.find(
          (p) => p.name === "smartBpmConclusionButton",
        );

        if (property) {
          commands.push(
            cmdHelper.updateBusinessObject(element, property, {
              value: values.smartBpmConclusionButton || "",
            }),
          );
        } else {
          const newProperty = elementHelper.createElement(
            "camunda:Property",
            {
              name: "smartBpmConclusionButton",
              value: values.smartBpmConclusionButton || "",
            },
            propertiesElement,
            bpmnFactory,
          );
          commands.push(
            cmdHelper.addElementsTolist(element, propertiesElement, "values", [
              newProperty,
            ]),
          );
        }

        return commands;
      },
    }),
  );

  group.entries.push(
    entryFactory.textField(translate, {
      id: "form-conclusion-button",
      label: translate('Texto do botão "Concluir"'),
      modelProperty: "formConclusionButton",
      hidden(element) {
        return !hasStepperField(element);
      },
      get(element) {
        const businessObject = getBusinessObject(element);
        const extension = businessObject.extensionElements;
        if (extension && extension.values) {
          const props = extension.values.find(
            (el) => el.$type === "camunda:Properties",
          );
          if (props && props.values) {
            const prop = props.values.find(
              (p) => p.name === "formConclusionButton",
            );
            if (prop) {
              return { formConclusionButton: prop.value };
            }
          }
        }
        return { formConclusionButton: "" };
      },
      set(element, values) {
        const commands = [];
        const businessObject = getBusinessObject(element);
        let extension = businessObject.extensionElements;
        if (!extension) {
          extension = elementHelper.createElement(
            "bpmn:ExtensionElements",
            { values: [] },
            businessObject,
            bpmnFactory,
          );
          commands.push(
            cmdHelper.updateBusinessObject(element, businessObject, {
              extensionElements: extension,
            }),
          );
        }
        let props = extension.values.find(
          (el) => el.$type === "camunda:Properties",
        );
        if (!props) {
          props = elementHelper.createElement(
            "camunda:Properties",
            { values: [] },
            extension,
            bpmnFactory,
          );
          commands.push(
            cmdHelper.addElementsTolist(element, extension, "values", [props]),
          );
        }
        const existing = props.values.find(
          (p) => p.name === "formConclusionButton",
        );
        if (existing) {
          commands.push(
            cmdHelper.updateBusinessObject(element, existing, {
              value: values.formConclusionButton || "",
            }),
          );
        } else {
          const newProp = elementHelper.createElement(
            "camunda:Property",
            {
              name: "formConclusionButton",
              value: values.formConclusionButton || "",
            },
            props,
            bpmnFactory,
          );
          commands.push(
            cmdHelper.addElementsTolist(element, props, "values", [newProp]),
          );
        }
        return commands;
      },
    }),
  );

  group.entries.push(
    entryFactory.textField(translate, {
      id: "form-previews-button",
      label: translate('Texto do botão "Voltar"'),
      modelProperty: "formPreviewsButton",
      hidden(element) {
        return !hasStepperField(element);
      },
      get(element) {
        const businessObject = getBusinessObject(element);
        const extension = businessObject.extensionElements;
        if (extension && extension.values) {
          const props = extension.values.find(
            (el) => el.$type === "camunda:Properties",
          );
          if (props && props.values) {
            const prop = props.values.find(
              (p) => p.name === "formPreviewsButton",
            );
            if (prop) {
              return { formPreviewsButton: prop.value };
            }
          }
        }
        return { formPreviewsButton: "" };
      },
      set(element, values) {
        const commands = [];
        const businessObject = getBusinessObject(element);
        let extension = businessObject.extensionElements;
        if (!extension) {
          extension = elementHelper.createElement(
            "bpmn:ExtensionElements",
            { values: [] },
            businessObject,
            bpmnFactory,
          );
          commands.push(
            cmdHelper.updateBusinessObject(element, businessObject, {
              extensionElements: extension,
            }),
          );
        }
        let props = extension.values.find(
          (el) => el.$type === "camunda:Properties",
        );
        if (!props) {
          props = elementHelper.createElement(
            "camunda:Properties",
            { values: [] },
            extension,
            bpmnFactory,
          );
          commands.push(
            cmdHelper.addElementsTolist(element, extension, "values", [props]),
          );
        }
        const existing = props.values.find(
          (p) => p.name === "formPreviewsButton",
        );
        if (existing) {
          commands.push(
            cmdHelper.updateBusinessObject(element, existing, {
              value: values.formPreviewsButton || "",
            }),
          );
        } else {
          const newProp = elementHelper.createElement(
            "camunda:Property",
            {
              name: "formPreviewsButton",
              value: values.formPreviewsButton || "",
            },
            props,
            bpmnFactory,
          );
          commands.push(
            cmdHelper.addElementsTolist(element, props, "values", [newProp]),
          );
        }
        return commands;
      },
    }),
  );

  group.entries.push(
    entryFactory.textField(translate, {
      id: "form-next-button",
      label: translate('Texto do botão "Avançar"'),
      modelProperty: "formNextButton",
      hidden(element) {
        return !hasStepperField(element);
      },
      get(element) {
        const businessObject = getBusinessObject(element);
        const extension = businessObject.extensionElements;
        if (extension && extension.values) {
          const props = extension.values.find(
            (el) => el.$type === "camunda:Properties",
          );
          if (props && props.values) {
            const prop = props.values.find((p) => p.name === "formNextButton");
            if (prop) {
              return { formNextButton: prop.value };
            }
          }
        }
        return { formNextButton: "" };
      },
      set(element, values) {
        const commands = [];
        const businessObject = getBusinessObject(element);
        let extension = businessObject.extensionElements;
        if (!extension) {
          extension = elementHelper.createElement(
            "bpmn:ExtensionElements",
            { values: [] },
            businessObject,
            bpmnFactory,
          );
          commands.push(
            cmdHelper.updateBusinessObject(element, businessObject, {
              extensionElements: extension,
            }),
          );
        }
        let props = extension.values.find(
          (el) => el.$type === "camunda:Properties",
        );
        if (!props) {
          props = elementHelper.createElement(
            "camunda:Properties",
            { values: [] },
            extension,
            bpmnFactory,
          );
          commands.push(
            cmdHelper.addElementsTolist(element, extension, "values", [props]),
          );
        }
        const existing = props.values.find((p) => p.name === "formNextButton");
        if (existing) {
          commands.push(
            cmdHelper.updateBusinessObject(element, existing, {
              value: values.formNextButton || "",
            }),
          );
        } else {
          const newProp = elementHelper.createElement(
            "camunda:Property",
            { name: "formNextButton", value: values.formNextButton || "" },
            props,
            bpmnFactory,
          );
          commands.push(
            cmdHelper.addElementsTolist(element, props, "values", [newProp]),
          );
        }
        return commands;
      },
    }),
  );

  smartFormGerarLinkPublicoButton(
    group,
    element,
    bpmnFactory,
    {},
    translate,
    modeling,
  );
}
